import { inject, Injectable } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {JobboardAdapter} from '../adapters/jobboard.adapter';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class RefService {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly jobboardAdapter = inject(JobboardAdapter);

  refCompany: boolean;

  utm_source: string;
  utm_campaign: string;
  utm_content: string;
  trackedIds: number[] = [];

  constructor() {
    this.utm_source = undefined;
    const urlParams = new URLSearchParams(window.location.search);
    const utmSourceParam = urlParams.get('utm_source');
    if (utmSourceParam && utmSourceParam !== '') {
      this.utm_source = utmSourceParam;
    } else {
      this.utm_source = document.referrer ?? '';
    }

    this.router.events.pipe(untilDestroyed(this)).subscribe({
      next: event => {
        if (event instanceof NavigationEnd) {
          const ref = this.route.snapshot.queryParams['ref'];
          if (this.route.snapshot.queryParams['ref']) {
            this.refCompany = ref === 'company';
          }
          if (this.route.snapshot.queryParams['utm_campaign'] && this.route.snapshot.queryParams['utm_campaign'] !== '') {
            this.utm_campaign = this.route.snapshot.queryParams['utm_campaign'];
          } else if (
            this.route.snapshot.queryParams['hidden_referrer'] &&
            this.route.snapshot.queryParams['hidden_referrer'] !== ''
          ) {
            this.utm_campaign = this.route.snapshot.queryParams['hidden_referrer'] ?? '';
          }
          if (this.route.snapshot.queryParams['utm_content'] && this.route.snapshot.queryParams['utm_content'] !== '') {
            this.utm_content = this.route.snapshot.queryParams['utm_content'];
          }
        }
      },
    });
  }

  countJobClick(companyId: number, jobId: number) {
    if (this.trackedIds.includes(jobId)) return;

    this.jobboardAdapter
      .countJobClick(companyId, jobId, {
        utm_source: this.utm_source,
        utm_campaign: this.utm_campaign,
      })
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.trackedIds.push(jobId);
        },
      });
  }
}
